export const RouteConstant = {
    ROOT: '/',
    LOGIN: "/",
    DASHBOARD: "/dashboard",
    USERS: "/users",
    VESSEL: "/vessel",
    SECTIONPROGRESS: "/section_progress",
    QUESTIONPROGRESS: "/question_progress",
    REMARKSCREEN: "/remarks"
}